import type * as lazyIndex from './lazyIndex';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule(
    () => import(/* webpackChunkName: "AppBoot" */ './lazyIndex'),
    { name: 'AppBoot' }
);

export const lazyMailAppBootstrap: LazyAction<
    typeof lazyIndex.mailAppBootstrap,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.mailAppBootstrap);
